import React from 'react';
import { Navigate } from 'react-router-dom';
import { Button, Container, Box, Typography } from '@mui/material';
import { useAuth0 } from '@auth0/auth0-react';
import Loading from '../Common/Loading';

const SignInPage = () => {
  const { loginWithRedirect, isAuthenticated, isLoading } = useAuth0();
  
  if (isLoading) {
    return <Loading />;
  }

  if (isAuthenticated) {
    return <Navigate to="/dashboard" />;
  }

  return (
    <Container maxWidth="sm">
      <Box sx={{ mt: 4, mb: 4, textAlign: 'center' }}>
        <Typography variant="h4" gutterBottom>
          Welcome Back
        </Typography>
        <Typography variant="body1" sx={{ mb: 3 }}>
          Sign in to manage your tattoo business
        </Typography>
        
        {/* Auth0 Sign In Button */}
        <Button
          variant="contained"
          color="primary"
          sx={{ 
            mt: 2, 
            mb: 3, 
            py: 1.5, 
            width: '100%',
            backgroundColor: '#635BFF',
            '&:hover': {
              backgroundColor: '#4F46E5',
            },
          }}
          onClick={() => loginWithRedirect({
            redirectUri: window.location.origin + '/callback',
          })}
        >
          Sign In with Auth0
        </Button>
        
        <Box sx={{ mt: 3, textAlign: 'center' }}>
          <Typography variant="body2">
            Don't have an account? <a href="/signup" style={{ color: '#635BFF' }}>Sign Up</a>
          </Typography>
          <Typography variant="body2" sx={{ mt: 1 }}>
            <a href="/forgotpassword" style={{ color: '#635BFF' }}>Forgot Password?</a>
          </Typography>
        </Box>
      </Box>
    </Container>
  );
};

export default SignInPage;